import { createContext, useContext } from 'react';
import { TreeProps } from './types';

type TreeContextValue = Pick<TreeProps, 'showCount' | 'multiple' | 'size'>;

const TreeContext = createContext<TreeContextValue | null>(null);

export const TreeContextProvider = TreeContext.Provider;

export const useTreeContext = () => {
    const context = useContext(TreeContext);
    if (!context) {
        throw Error('TreeContext not initialized');
    }
    return context;
};

const ExpandedContext = createContext<boolean>(true);

export const ExpandedContextProvider = ExpandedContext.Provider;

export const useExpandedContext = () => {
    const context = useContext(ExpandedContext);

    if (context === undefined) {
        throw Error('ExpandedContext not initialized');
    }

    return context;
};
